var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mis-visitas" },
    [
      _c("WidgetUser"),
      _c(
        "v-flex",
        { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
        [
          _c("FiltrosBusqueda", {
            attrs: {
              defaultEstado: _vm.defaultEstado,
              rutClienteDefecto: _vm.rutClienteDefecto,
              listaEmpresas: _vm.listaEmpresas,
              listaEstados: _vm.listaEstados,
              listaPatentes: _vm.listaPatentes,
              categoriaUsuario: _vm.categoriaUsuario
            },
            on: {
              resultadoBusqueda: _vm.filtroVisitas,
              clear: _vm.VisitaInicial
            }
          }),
          _vm.showExport
            ? _c(
                "v-flex",
                {
                  staticStyle: { "align-self": "end" },
                  attrs: {
                    "offset-md2": "",
                    "offset-sm2": "",
                    sm1: "",
                    md1: ""
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { "padding-top": "15px" },
                      attrs: { align: "right" }
                    },
                    [
                      _vm.visitas.length
                        ? _c("ExportCsv", { attrs: { visitas: _vm.visitas } })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card autoHeightGrid" },
        [
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                "offset-md10": "",
                "offset-sm10": "",
                sm2: "",
                md2: ""
              }
            },
            [
              _c("v-text-field", {
                staticStyle: { "margin-right": "5px" },
                attrs: { label: "Buscar..." },
                model: {
                  value: _vm.filtrobusquedagrilla,
                  callback: function($$v) {
                    _vm.filtrobusquedagrilla = $$v
                  },
                  expression: "filtrobusquedagrilla"
                }
              })
            ],
            1
          ),
          _c("TablaMisVisitas", {
            attrs: { visitas: _vm.visitas, busqueda: _vm.filtrobusquedagrilla }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }